import updateProjectField from '../Services/updateProjectField';
import fetch from '../../../Services/fetch';

export default (id, field, value) => async (dispatch) => {

  await dispatch(updateProjectField(id, field, value));

  await dispatch(fetch());
  
}